import React from 'react';
import { IStandardDocumentVersionData } from '../../../../../types/order/documents/shared/interfaces';
import { IFetchStatus } from '../../../../../types/rest/IFetchStatus';
import { BodyText, FlexRow, Grid, NavigationItem } from '../../../../../ui-toolkit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileArrowUp } from '@fortawesome/pro-regular-svg-icons';
import { DeleteLink } from './DeleteLink';
import { PublicationLinks } from './PublicationLinks';
import { downloadDocument } from '../../../../../API/order/documents/downloadDocument';
import { DateFormat, getDateString } from '../../../../../ui-toolkit/utilities/getDateString';

export interface IShowPolicyDocumentDataProps {
  document: IStandardDocumentVersionData;
  label: string;
  isAmericanDigital: boolean;
  deleteFetchStatus: IFetchStatus;
  actionFetchStatus: IFetchStatus;
  onDelete: (docId: string, versionId: string) => void;
  onUnpublish: (docId: string) => void;
  onPublish: (docId: string) => void;
}

export const ShowPolicyDocumentData: React.FC<IShowPolicyDocumentDataProps> = ({
  document,
  label,
  onDelete,
  onUnpublish,
  onPublish,
  deleteFetchStatus,
  actionFetchStatus,
  isAmericanDigital,
}) => {
  return (
    <Grid>
      <FlexRow>
        <FontAwesomeIcon icon={faFileArrowUp} />
        <NavigationItem
          text={label}
          onClick={() => downloadDocument(document.id, document.versionId, document.fileName)}
          isInline
        />
        <DeleteLink
          isAmericanDigital={isAmericanDigital}
          fetchingStatus={deleteFetchStatus.fetching}
          onDelete={onDelete}
          document={document}
        />
      </FlexRow>
      <PublicationLinks
        isAmericanDigital={isAmericanDigital}
        document={document}
        fetchingStatus={actionFetchStatus.fetching}
        onUnpublish={onUnpublish}
        onPublish={onPublish}
      />
      <BodyText>
        {isAmericanDigital ? 'Generated' : 'Uploaded'} On:
        {getDateString(DateFormat.hugeDateTime, document.updatedAt, true)}
      </BodyText>
    </Grid>
  );
};
